import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import type { DayFlowPoint } from "@/core/analytics/analytics-utils";
import { formatMoneyCompact } from "@/core/pharmacy/format";

interface TreasuryFlowChartProps {
  data: DayFlowPoint[];
}

export function TreasuryFlowChart({ data }: TreasuryFlowChartProps) {
  return (
    <div className="ph-chart-wrap">
      <ResponsiveContainer width="100%" height={260}>
        <BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
          <XAxis
            dataKey="label"
            tick={{ fontSize: 11, fill: "#64748b" }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{ fontSize: 11, fill: "#64748b" }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip
            cursor={{ fill: "rgba(124, 58, 237, 0.06)" }}
            content={({ active, payload, label }) => {
              if (!active || !payload?.length) return null;
              return (
                <div
                  style={{
                    padding: "8px 12px",
                    borderRadius: 8,
                    border: "1px solid #e2e8f0",
                    background: "#fff",
                    fontSize: 13,
                  }}
                >
                  <div className="fw-semibold mb-1">{label}</div>
                  {payload.map((entry) => (
                    <div key={String(entry.dataKey)}>
                      {entry.name} : {formatMoneyCompact(Number(entry.value))}
                    </div>
                  ))}
                </div>
              );
            }}
          />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <Bar dataKey="inflows" name="Entrées" fill="#0d9488" radius={[4, 4, 0, 0]} maxBarSize={28} />
          <Bar dataKey="outflows" name="Sorties" fill="#f59e0b" radius={[4, 4, 0, 0]} maxBarSize={28} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
